import Container from 'react-bootstrap/Container';
import InventoryList from '../modules/ListInventory';

interface ApplicationProps {
    updatefunc: () => void;
}

function InventoryPage({updatefunc}: ApplicationProps){
    return (
        <> 
            <Container>
                <InventoryList updatefunc={updatefunc} />           
            </Container>
        </>
    )
}

export default InventoryPage;